import type { FC } from 'react';

import type { GenericSvgIconProps } from '../CustomIcon';

// Icons used on CardStackCard component
export const CardStackArrowRight: FC<GenericSvgIconProps> = props => {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M10.876 18.7199C10.2416 19.3559 10.2416 20.387 10.876 21.023C11.5103 21.659 12.5388 21.659 13.1732 21.023L21.0242 13.1516C21.6586 12.5156 21.6586 11.4844 21.0242 10.8484L13.1732 2.977C12.5388 2.341 11.5103 2.341 10.876 2.977C10.2416 3.613 10.2416 4.64415 10.876 5.28015L15.9541 10.3714L4.12436 10.3714C3.22725 10.3714 2.5 11.1006 2.5 12C2.5 12.8994 3.22725 13.6286 4.12436 13.6286L15.9541 13.6286L10.876 18.7199Z" />
    </svg>
  );
};
